import { render, staticRenderFns } from "./FruitsVegTypes.vue?vue&type=template&id=3450a566&scoped=true&"
import script from "./FruitsVegTypes.vue?vue&type=script&lang=js&"
export * from "./FruitsVegTypes.vue?vue&type=script&lang=js&"
import style0 from "./FruitsVegTypes.vue?vue&type=style&index=0&id=3450a566&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3450a566",
  null
  
)

export default component.exports